import { PrimaryButton } from '@axafr-btc-ds/buttons';
import { Typography } from '@axafr-btc-ds/typography';
import styles from './OfferDescription.module.css';
import { OfferDescriptionProps } from './OfferDescription.interface';
import { Price } from 'components/price';
import { InsuredCardImage } from 'components/images';
import { Card } from 'components/card';
import classNames from 'classnames';
import GuaranteeModal from 'components/modal/guarantee-modal/GuaranteeModal';
import { Link } from '@axafr-btc-ds/link';
import { useState } from 'react';

export const OfferDescription = ({
    mode,
    tarifMensuel,
    tarifAnnuel,
    onPrimaryClick,
}: OfferDescriptionProps) => {
    const [ isOpen, setIsOpen ] = useState<boolean>(false);
    return (
        <Card
            className={ classNames(styles.host, { [ styles.flat ]: mode === 'flat' }) }
            onClick={ () => {
                setIsOpen(!isOpen);
            } }
        >
            <div className={ styles.image }>
                <InsuredCardImage />
            </div>
            <div className={ styles.container }>
                <div>
                    <Price amount={ tarifMensuel } suffix=' / mois*' />
                    <p className={ styles.annualPrice }>soit { tarifAnnuel } € / an*</p>
                </div>
                <div>
                    <Link data-testid='linkToModal' className={ styles.linkToModal } onClick={ () => {} }>
                        Comment ce tarif est-il calculé ?
                    </Link>
                </div>

                <div className={ styles.modalPosition }>
                    <GuaranteeModal
                        title={ 'Comment ce tarif est-il calculé ?' }
                        isOpen={ isOpen }
                        data={ { '': 'Notre tarificateur prend en compte les premières informations que vous nous avez transmises (modèle, profil de conducteur, localité...) '
                            + 'pour vous proposer un tarif minimum.\n\nPour vous donner une vision rapide du coût de votre assurance, certains critères qui entrent dans la '
                            + 'composition de votre cotisation sont prédéterminés et ne correspondent peut-être pas à votre situation.\n\nD\'où la nécessité de vous poser '
                            + 'd\'autres questions pour affiner ce tarif et vous proposer la bonne assurance au prix le plus juste.',
                        } }
                        onClose={ () => {
                            setIsOpen(false);
                        } }
                    />
                </div>
                <Typography component="p" variant="body1" className={ styles.body }>
                    <span>Cette proposition vous intéresse ? </span>Un conseiller vous rappelle pour la suite !
                </Typography>
                <div className={ styles.actions }>
                    <PrimaryButton
                        align='center'
                        className={ styles.actionBtn }
                        onClick={ onPrimaryClick }
                    >
                Finaliser mon tarif
                    </PrimaryButton>
                </div>
            </div>
        </Card>
    );
};
